import { FilterCollapsableWrapper } from '../../FiltersWrappers/FilterCollapsableWrapper/FilterCollapsableWrapper';
import CustomSimpleSelector from './customSimpleSelector/customSimpleSelector';

interface SimpleSelectorProps {
  filterType: string;
  disableScroll?: boolean;
  noBottomDivider?: boolean;
}

export const SimpleSelector = ({ filterType, noBottomDivider }: SimpleSelectorProps) => {
  return (
    <>
      <FilterCollapsableWrapper
        filterType={filterType}
        noBottomDivider={noBottomDivider}
      >
        <CustomSimpleSelector filterType={filterType} />
      </FilterCollapsableWrapper>
    </>
  );
};
